interface QuoteHeaderProps {
  id?: string;
  title: string;
  company: string;
  quantity: string;
  location: string;
}

export const QuoteHeader = ({ id, title, company, quantity, location }: QuoteHeaderProps) => (
  <div className="mb-6">
    <h1 className="text-3xl font-bold text-foreground mb-2">
      Submit Quote for {id}
    </h1>
    <div className="bg-accent/50 border border-accent rounded-lg p-4">
      <h2 className="font-semibold text-lg text-accent-foreground mb-1">
        {title}
      </h2>
      <div className="text-sm text-muted-foreground">
        <span className="mr-4">Company: {company}</span>
        <span className="mr-4">Quantity: {quantity}</span>
        <span>Location: {location}</span>
      </div>
    </div>
  </div>
);
